var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 flex"},[_c('div',{staticClass:"max-w-7/8 md:max-w-3/4"},[_c('div',{staticClass:"p-4 bg-primary text-white rounded"},[_c('p',[_vm._t("message")],2)]),_c('span',{staticClass:"mt-2 block"},[_vm._t("time")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }